import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-just-white-body',
  templateUrl: './just-white-body.component.html',
  styleUrls: ['./just-white-body.component.scss'],
})
export class JustWhiteBodyComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
